import { useCallback, useState } from 'react';
import { useSensor } from '@streem/ui-react';
import { recordTradeClicked } from '../components/in_call/tool_bar/tools/call_transfer/analytics-utils';
export function useTradeRow(name, disabled, onRequeueTrade, tradeMenuButtonRef, requeueButtonRef) {
    const color = disabled ? 'grey30' : 'grey90';
    const [showPopup, setShowPopup] = useState(false);
    const requeueTrade = useCallback(async function (name) {
        await onRequeueTrade(name);
        setShowPopup(false);
    }, [onRequeueTrade, setShowPopup]);
    const onClick = useCallback(function () {
        if (!disabled) {
            setShowPopup(prev => !prev);
            recordTradeClicked(name);
        }
    }, [setShowPopup, disabled, name]);
    const closeRequeueTradePopup = useCallback(() => {
        setShowPopup(false);
    }, [setShowPopup]);
    const onClickOutsideMenuRowButton = (event) => {
        const clickedOnRequeueButton = !!requeueButtonRef.current?.contains(event?.target);
        if (!clickedOnRequeueButton) {
            closeRequeueTradePopup();
        }
    };
    useSensor(onClickOutsideMenuRowButton, closeRequeueTradePopup, tradeMenuButtonRef);
    return {
        color,
        showPopup,
        requeueTrade,
        onClick,
        closeRequeueTradePopup,
        onClickOutsideMenu: onClickOutsideMenuRowButton,
    };
}
//# sourceMappingURL=use_trade_row.js.map